import React from 'react';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import styles from './consignment-form-header.module.scss';

const ConsignmentFormHeader: React.FC = () => {
  const { t } = useTranslation();

  return (
    <header className={clsx(styles.consignmentForm__header)}>
      <h1 className={clsx(styles.consignmentForm__header__title, 'vc-title-s')}>{t('CONSIGNMENT.FORM.TITLE')}</h1>
      <p className={clsx(styles.consignmentForm__header__intro, 'vc-text-l')}>{t('CONSIGNMENT.FORM.INTRO')}</p>
    </header>
  );
};

export default ConsignmentFormHeader;
